import styled from 'styled-components';
import { colors } from '../../style/colors';
import { max } from '../../lib/responsive';
import { H3, SmallP } from '../../style/typography';

const SectionContainer = styled.div`
  padding-bottom: 12.5rem;
  padding-top: 7.188rem;
  display: flex;
  background-color: ${colors.YELLOW};
  height: auto;
  justify-content: space-evenly;
  align-items: center;

  @media ${max.tabletLg} {
    flex-direction: column;
    padding-top: 5.188rem;
    padding-bottom: 0;
  }

  @media ${max.tabletSm} {
    padding-top: 2rem;
  }
`;

const LogoImage = styled.img`
  width: 23.214rem;
  height: 24.375rem;
  margin-top: 9.375rem;

  @media ${max.desktop} {
    margin-right: 6.25rem;
  }

  @media ${max.tabletLg} {
    align-self: flex-end;
    margin-top: 5.438rem;
    margin-right: 2.5rem;
  }

  @media ${max.tablet} {
    max-width: 60%;
    height: auto;
  }
`;

const SectionTextContainer = styled.div`
  display: block;
`;

const SectionTitle = styled(H3)`
  letter-spacing: 0.01em;
`;

const SectionText = styled(SmallP)`
  width: 36.25rem;

  @media ${max.desktop} {
    width: auto;
  }
`;

const ButtonContainer = styled.div`
  margin-top: 4.625rem;

  @media ${max.tabletLg} {
    margin-top: 2.75rem;
  }
`;

export {
  SectionContainer,
  LogoImage,
  SectionTextContainer,
  SectionTitle,
  SectionText,
  ButtonContainer,
};
